export default "__VITE_ASSET__D_2522JI__"